import React from 'react';

const EmptyState = ({ icon, title, description, actions, className = '' }) => (
  <div className={`empty-state ${className}`.trim()}>
    {icon && <div className="empty-state-icon">{icon}</div>}
    <h2>{title}</h2>
    {description && <p>{description}</p>}
    {actions && <div className="empty-state-actions">{actions}</div>}
  </div>
);

export default EmptyState;
